// Maps canonical Italian outcome values (stored in DB) to i18n keys.
export const OUTCOME_TKEY = {
  'Primo Deposito Effettuato': 'outcome_first_deposit',
  Appuntamento: 'outcome_appointment',
  Richiamo: 'outcome_callback',
  'Non Interessato': 'outcome_not_interested',
  'Non Risponde': 'outcome_no_answer',
  Segreteria: 'outcome_voicemail',
  'Numero Errato': 'outcome_wrong_number',
  'Numero Inesistente': 'outcome_non_existent',
  Occupato: 'outcome_busy',
  'Cliente già registrato': 'outcome_already_registered',
  'Cliente indeciso': 'outcome_undecided',
  'Cliente richiede informazioni': 'outcome_needs_info',
  'Da ricontattare': 'outcome_to_recontact',
  'Chiamata interrotta': 'outcome_call_interrupted',
  'Cliente non idoneo': 'outcome_not_eligible',
};

// t: translation function from LanguageContext.
export const localizeOutcome = (t, value) => {
  if (!value) return '';
  const key = OUTCOME_TKEY[value];
  if (!key) return value;
  const translated = t(key);
  return translated || value;
};
